import { Link } from 'react-router-dom';

function getRandom(arr, n) {
  var result = new Array(n),
    len = arr.length,
    taken = new Array(len);
  if (n > len) throw new RangeError('getRandom: more elements taken than available');
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

export default function Interested(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { machineID, t, prods } = props;
  let products = JSON.parse(localStorage.getItem('bestSeller'));
  if (!products || products?.length === 0) {
    products = prods;
  }
  if (products?.length > 4) {
    products = getRandom(products, 4);
  }

  const images = products.map((product) => {
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${product.productPictures[0]}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${product.productPictures[0]}/${product.referTo}`;
    return (
      <Link key={product._id} to={`/machineUI/product/${machineID}/${product._id}/${product.idx}`}>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            height: '150px',
            width: '150px',
            backgroundColor: 'white',
          }}
        >
          <img
            style={{
              maxHeight: '90%',
              maxWidth: '90%',
              borderRadius: '4px',
            }}
            key={product._id}
            src={url}
            alt="image"
          />
        </div>
      </Link>
    );
  });

  return (
    <div>
      <div className="horizontal_dotted_line"></div>
      <div className="d-flex justify-content-start mt-3">
        <span
          style={{
            fontSize: '40px',
          }}
          className="cat-title mb-5"
        >
          {t('You may be also interested in')}
        </span>
      </div>
      <div
        className="d-flex"
        style={{
          justifyContent: 'space-evenly',
        }}
      >
        {images}
      </div>
    </div>
  );
}
